import { ThemeColors } from '~/themes/colors'

import {
  experimentsColors,
  helpListItemColors,
  profileColors,
  settingsButtonColors,
  settingsPanelColors,
  shortcutsColors,
  snippetsColors,
  tabListColors,
} from './parts'

export interface SettingsColors {
  Background: ThemeColors
  SettingsButton: typeof settingsButtonColors
  SettingsPanel: typeof settingsPanelColors
  HelpListItem: typeof helpListItemColors
  TabList: typeof tabListColors
  Profile: typeof profileColors
  Snippets: typeof snippetsColors
  Experiments: typeof experimentsColors
  Shortcuts: typeof shortcutsColors
}

export const settingsColors: SettingsColors = {
  Background: {
    default: 'gray.300',
  },
  SettingsButton: settingsButtonColors,
  SettingsPanel: settingsPanelColors,
  HelpListItem: helpListItemColors,
  TabList: tabListColors,
  Profile: profileColors,
  Snippets: snippetsColors,
  Experiments: experimentsColors,
  Shortcuts: shortcutsColors,
}
